import React from "react";

export default function ScrollDownIcon() {
    return <div className="mouse"></div>;
}
